var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-3 bg-white p-3 shadow-lg rounded-lg",staticStyle:{"min-height":"300px"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }